export const blockIconsNotificationSmsFailed = (
	<span className='material-symbols-outlined'>sms_failed</span>
);
